import React, { forwardRef } from 'react';
import BaseButton from '../BaseButton';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const HistoryButton = forwardRef(({ title = 'History', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='history-tab-button'
    className='history-tab-button'
    title={title}
    {...props}
  />
));

export default HistoryButton;
